import styled, { css } from 'styled-components';

import { IS_CLOUD } from '@qality/common-config';

export const DC_NAVBAR_HEIGHT_PX = '41px';

export const CONTAINER_HEIGHT = IS_CLOUD
  ? css`
      height: 100vh;
    `
  : css`
      height: calc(100vh - ${DC_NAVBAR_HEIGHT_PX});
    `;

/**
 * For the unknown reason on the DC, the PageLayout completely ignores the Jira Layout,
 * and puts the LeftSidebar under the Jira Navbar and banners.
 * This is override to move the sidebar to the correct place.
 */
export const DC_LEFT_SIDEBAR_POSITION_OVERRIDE =
  !IS_CLOUD &&
  css`
    div[data-ds--page-layout--slot='left-sidebar'] {
      div:first-of-type {
        position: sticky !important;
      }
    }
  `;

export const PAGE_PADDING_LEFT_PX = '16px';
export const PAGE_PADDING_RIGHT_PX = '16px';
export const PAGE_PADDING_TOP_PX = '16px';
export const PAGE_PADDING_BOTTOM_PX = '16px';

export const MainContainerStyled = styled.div`
  box-sizing: border-box;
  padding: ${PAGE_PADDING_TOP_PX} ${PAGE_PADDING_RIGHT_PX}
    ${PAGE_PADDING_BOTTOM_PX} ${PAGE_PADDING_LEFT_PX};

  ${CONTAINER_HEIGHT}

  overflow: hidden;
  display: flex;
  flex-direction: column;
  gap: 16px;
`;

export const LeftSidebarContainerStyled = styled.div`
  box-sizing: border-box;
  padding: 16px;

  ${CONTAINER_HEIGHT}

  background: var(--ds-surface, var(--ds-fb-surface));

  display: grid;
  grid-template: min-content 1fr / 1fr;
  gap: 8px;
`;
